import Vue from 'vue'
import store from '../store/store.js'
import VueRouter from 'vue-router'
import {Role} from './_helper'

function lazyLoad(view){
  return() => import(/* webpackChunkName: "[request]" */ `@/views/${view}.vue`)
}
function lazyLoadComponent(view){
  return() => import(/* webpackChunkName: "[request]" */ `@/components/${view}.vue`)
}


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/secure/calendar',
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater, Role.ManageTeacher, Role.ManageStudent] } 
  },
  // {
  //   path: '/schedule-central',
  //   name: 'ScheduleCentral',
  //   component: lazyLoadComponent('schedule/ScheduleCentral'),
  //   meta: { authorize: [Role.Admin, Role.Director, Role.Floater, Role.ManageTeacher, Role.ManageStudent] } 
  // },
  {
    path: '/print-schedules',
    name: 'PrintSchedules',
    component: lazyLoadComponent('schedule/PrintSchedules'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater, Role.ManageTeacher, Role.ManageStudent] } 
  },
  {
    path: '/product/:id',
    name: 'Product',
    component: lazyLoad('Product'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater] } 
  },
  {
    path: '/secure/teachers',
    name: 'Teachers',
    component: lazyLoad('secure/teacher/Teachers'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater,  Role.ManageTeacher] } 
  },
  {
    path: '/secure/teacher/:id/:tab?',
    name: 'Teacher',
    component: lazyLoad('secure/teacher/Teacher'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater,  Role.ManageTeacher] } 
  },
  {
    path: '/secure/new-teacher',
    name: 'NewTeacher',
    component: lazyLoad('secure/teacher/NewTeacher'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater,  Role.ManageTeacher] } 
  },
  {
    path: '/secure/edit-teacher/:id',
    name: 'EditTeacher',
    component: lazyLoadComponent('teacher/EditTeacher'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater,  Role.ManageTeacher] } 
  },
  {
    path: '/secure/teacher-availability/:teacherId/:id?',
    name: 'TeacherAvailability',
    component: lazyLoad('secure/teacher/TeacherAvailability'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater,  Role.ManageTeacher] } 
  },
  {
    path: '/secure/teacher-rate/:teacherId/:id?',
    name: 'TeacherRate',
    component: lazyLoad('secure/teacher/TeacherRate'),
    meta: { authorize: [Role.Admin, Role.Director, Role.ManageSchedule, Role.ManageTeacherRate] } 
  },
  {
    path: '/secure/teacher-timesheet-record/:teacherId/:id?',
    name: 'TeacherTimeRecord',
    component: lazyLoad('secure/teacher/TeacherTimeRecordForm'),
    meta: { authorize: [Role.Admin, Role.Director,  Role.ManageTeacher] } 
  },
  {
    path: '/secure/teacher-schedule/:teacherId/:id?',
    name: 'TeacherSchedule',
    component: lazyLoad('secure/teacher/TeacherSchedule'),
    meta: { authorize: [Role.Admin, Role.Director,  Role.ManageTeacher] } 
  },
  {
    path: '/secure/schedules',
    name: 'StaffSchedule',
    component: lazyLoad('secure/schedule/StaffSchedule'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater] } 
  },
  {
    path: '/secure/student/:id?',
    name: 'Student',
    component: lazyLoad('secure/Student'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater,  Role.ManageStudent] } 
  },
  {
    path: "/reports/:reportName?",
    name: "Reports",
    component: lazyLoad("Reports"),
    meta: { authorize: [Role.Admin, Role.Director], requiresAuth: true},
  },
  {
    path: "/attendance",
    name: "Attendance",
    component: lazyLoadComponent("report/Attendance"),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater], requiresAuth: true},
  },
  {
    path: '/secure/orders',
    name: 'Orders',
    component: lazyLoad('secure/Orders'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater] } 
  },
  {
    path: '/secure/order/:id',
    name: 'OrderDetail',
    component: lazyLoad('secure/OrderDetail'),
    meta: { authorize: [Role.Admin, Role.Director] } 
  },
  {
    path: '/about',
    name: 'About',
    component: lazyLoad('About'),
    meta: { authorize: [] } 
  },
  {
    path: '/login',
    name: 'Login',
    component: lazyLoadComponent('auth/Login'),
    meta: { authorize: [] } 
  },
  {
    path: "/pwd-reset",
    name: "ResetPassword",
    component: lazyLoadComponent("auth/ResetPassword"),
    meta: { authorize: [] },
  },
  {
    path: '/register',
    name: 'Register',
    component: lazyLoadComponent('auth/Register'),
    meta: { authorize: [] } 
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: lazyLoadComponent('error/Unauthorized'),
    meta: { authorize: [] } 
  },
  {
    path: '/secure/myhome',
    name: 'MyHome',
    component: lazyLoad('secure/SecureHome'),
    meta: { authorize: [Role.Admin, Role.Director] } 
  },
  {
    path: '/secure/calendar/:calendarName?',
    name: 'Calendar',
    component: lazyLoad('secure/course/Calendar'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater] }
  },
  {
    path: '/secure/courses/management',
    name: 'CourseManagement',
    component: lazyLoad('secure/course/CourseManagement'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater] }
  },
  {
    path: '/secure/course/:id/:tab?',
    name: 'CourseDetail',
    component: lazyLoad('secure/course/CourseDetail'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater] }
  },
  {
    path: '/secure/course-people/substitute-teacher/:courseId/:scheduleId/:date',
    name: 'SubstituteTeacher',
    component: lazyLoadComponent('course/SubstituteTeacher'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater, Role.ManageTeacher] }
  },
  {
    path: '/secure/course-people/student/:courseId/:studentId?',
    name: 'CourseStudent',
    component: lazyLoadComponent('student/CourseStudent'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater] }
  },
  {
    path: '/secure/course-info/:courseId',
    name: 'CourseInfo',
    component: lazyLoadComponent('course/CourseInfo'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater] }
  },
  {
    path: '/secure/course-schedule/:courseId/:scheduleId?',
    name: 'CourseSchedule',
    component: lazyLoadComponent('course/LocalCourseSchedule'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater] }
  },
  {
    path: '/secure/newcourse',
    name: 'NewCourse',
    component: lazyLoad('secure/course/NewCourse'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater] }
  },
  {
    path: '/secure/manageapi',
    name: 'ManageApi',
    component: lazyLoad('secure/ManageApi'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Super] }
  },
  {
    path: '/secure/dataengine',
    name: 'dataEngine',
    component: lazyLoad('secure/DataEngine'),
    meta: { authorize: [Role.Admin, Role.Director] }
  },
  {
    path: '/secure/manageresources',
    name: 'ManageResources',
    component: lazyLoad('secure/ManageResources'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Super] }
  },
  {
    path: '/secure/standards',
    name: 'Standards',
    component: lazyLoad('secure/Standards'),
    meta: { authorize: [Role.Admin, Role.Director] }
  },
  // {
  //   path: '/secure/reset/password',
  //   name: 'ResetPassword',
  //   component: lazyLoad('secure/ResetPassword'),
  //   meta: { authorize: [Role.Admin, Role.Director, Role.Floater] }
  // },
  {
    path: '/secure/edit/course',
    name: 'EditCourse',
    component: lazyLoad('secure/EditCourse'),
    meta: { authorize: [Role.Admin, Role.Director, Role.Floater] }
  }
]

const router = new VueRouter({
  routes
})


function isAuthorized(authorize){
  if(!authorize || authorize.length < 1){
    return true;
  }

  let hasModule = false;
  const userModules = store.getters.userModules;
  if(userModules && userModules.length > 0){
    hasModule = userModules.some(m => m && m.path === 'control');
  }

  const userRoles = store.getters.userRoles;
  if(hasModule && userRoles && userRoles.length > 0){
    return userRoles.some(r => authorize.includes(r));
  }
  else{
    store.dispatch("addErrorMessage", 'Unauthorized Access');
    return false;
  }

}

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.path.startsWith('/secure/') || record.meta.requiresAuth)) {
    const { authorize } = to.meta;

    if (store.getters.isLoggedIn) {
      //is logged in and has authorized permission
      if(isAuthorized(authorize)){
        next()
        return
      }
      else{
        //Is logged in, but not authorized
        // store.dispatch("processLogout");
        next('/unauthorized')
      }
    }
    //not logged in
    else{
      //Check if jwt token exists and attempt to automatically log in
      store.dispatch("remoteJwtTokenCheck")
        .then( () => {
          //check if user is authorized
          if(isAuthorized(authorize)){
            next()
          }
          else{
            //not authorized
            store.dispatch("processLogout");
            next('/login')
          }
        })
        .catch( () => {
          // console.log('fail jwt token check')
          store.dispatch("processLogout");
          next('/login') 
        })
    }
  } else {
    //accessing non-secured page
    next()
  }
})


export default router
